import { Navigate, useLocation } from 'react-router-dom';

import { AppRoute } from 'routing/AppRoute.enum';

/**
 * Keeps v1's /main/dod/metrics working after Metryki was split into Przeglad and Retransmisje.
 *
 * The query string is carried across: it holds the range and filters, which is the only reason a
 * DOD link gets bookmarked in the first place. A bare <Navigate> would silently reset the view.
 */
export const DodMetricsRedirect = (): JSX.Element => {
  const { search } = useLocation();

  return <Navigate to={`${AppRoute.dodRetries}${search}`} replace />;
};
